// src/components/Footer.jsx
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';   // THIS IS THE ONLY CHANGE YOU NEED

const FooterWrapper = styled.footer`
  padding: 2rem 2rem 1rem;
  background: #000000;
`;

const FooterInner = styled.div`
  max-width: 1350px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  font-size: 0.95rem;
  color: #ffffff;
  letter-spacing: 0.5px;
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
  color: #aaaaaa;
  line-height: 1.5;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.75rem;
    text-align: center;
  }
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #333333;
  margin: 0.5rem 0;
  opacity: 0.6;
  width: 100%;
`;

const Left = styled.div`
  font-weight: 400;
  color: #aaaaaa;
`;

const RightLink = styled(Link)`   // CHANGED from <a> to <Link>
  color: #ffffff;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: all 0.3s ease;

  &:hover {
    color: #C8AB48;
    border-bottom-color: #C8AB48;
  }
`;

const CreditLink = styled.a`
  color: #C8AB48;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: all 0.3s ease;

  &:hover {
    color: #ffffff;
    border-bottom-color: #ffffff;
  }
`;

const Footer = () => {
  return (
    <FooterWrapper>
      <FooterInner>
        {/* Top row */}
        <TopRow>
          <Left>© 2025 Start Something Different Global</Left>
          <RightLink to="/privacy-policy">Privacy Policy</RightLink>  {/* to= instead of href= */}
        </TopRow>

        <Divider />

        {/* Bottom row */}
        <BottomRow>
          <Left>
            Registered Office: Start Something Different Global Ltd, Soho Works Shoreditch,
            Unit 4.07 The Tea Building, 56 Shoreditch High Street, London, E1 6JJ
          </Left>

          <div>
            Website by{' '}
            <CreditLink href="https://draftpoint.co.uk" target="_blank" rel="noopener noreferrer">
              draftpoint
            </CreditLink>
          </div>
        </BottomRow>
      </FooterInner>
    </FooterWrapper>
  );
};

export default Footer;